import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  nav_excursions: { ru: "Экскурсии", en: "Excursions" },
  nav_seasons: { ru: "Сезоны", en: "Seasons" },
  nav_map: { ru: "Карта", en: "Map" },
  nav_altai: { ru: "Об Алтае", en: "About Altai" },
  nav_guide: { ru: "О гиде", en: "The Guide" },
  nav_contacts: { ru: "Контакты", en: "Contacts" },
  nav_reviews: { ru: "Отзывы", en: "Reviews" },
  nav_places: { ru: "Места", en: "Destinations" },
  cta_choose_route: { ru: "Выбрать маршрут", en: "Choose a route" },
  cta_explore: { ru: "Исследовать маршруты", en: "Explore routes" },
  cta_map: { ru: "Смотреть карту", en: "View the map" },
  cta_request: { ru: "Запросить экскурсию", en: "Request excursion" },
  cta_open_route: { ru: "Открыть маршрут", en: "Open route" },
  cta_see_routes: { ru: "Смотреть маршруты", en: "See routes" },
  cta_meet: { ru: "Познакомиться", en: "Meet the guide" },
  cta_custom: { ru: "Собрать свой маршрут", en: "Design your journey" },
  cta_send: { ru: "Отправить запрос", en: "Send request" },
  scroll: { ru: "Листайте вниз", en: "Scroll to explore" },
  spring: { ru: "Весна", en: "Spring" },
  summer: { ru: "Лето", en: "Summer" },
  autumn: { ru: "Осень", en: "Autumn" },
  winter: { ru: "Зима", en: "Winter" },
  routes_count: { ru: "маршрутов", en: "routes" },
  duration: { ru: "Продолжительность", en: "Duration" },
  difficulty: { ru: "Сложность", en: "Difficulty" },
  season: { ru: "Сезон", en: "Season" },
  transport: { ru: "Транспорт", en: "Transport" },
  walking: { ru: "Пешая часть", en: "Walking" },
  children: { ru: "Дети", en: "Children" },
  category: { ru: "Категория", en: "Category" },
  all: { ru: "Все", en: "All" },
  filters: { ru: "Фильтры", en: "Filters" },
  price: { ru: "Стоимость", en: "Price" },
  attested: { ru: "Аттестованный экскурсовод", en: "Attested guide" },
  route_stages: { ru: "Точки маршрута", en: "Route highlights" },
  the_story: { ru: "История маршрута", en: "The story" },
  info: { ru: "Информация", en: "Information" },
  legal_safety: { ru: "Правовые и безопасностные аспекты", en: "Legal & safety" },
  form_name: { ru: "Имя", en: "Name" },
  form_phone: { ru: "Телефон", en: "Phone" },
  form_email: { ru: "Email", en: "Email" },
  form_date: { ru: "Желаемые даты", en: "Preferred dates" },
  form_adults: { ru: "Взрослые", en: "Adults" },
  form_children: { ru: "Дети", en: "Children" },
  form_comment: { ru: "Комментарий", en: "Comment" },
  form_preferred: { ru: "Предпочтительная связь", en: "Preferred contact" },
  form_consent: { ru: "Я согласен(на) на обработку персональных данных", en: "I consent to processing of my personal data" },
  thanks: { ru: "Спасибо! Мы свяжемся с вами в ближайшее время.", en: "Thank you! We will contact you shortly." },
  empty_title: { ru: "Такого маршрута пока нет.", en: "No such route yet." },
  empty_sub: { ru: "Попробуйте изменить фильтры или соберите индивидуальное путешествие.", en: "Try changing the filters or design a custom journey." },
  see_altai: { ru: "Увидимся на Алтае.", en: "See you in Altai." },
  positioning: { ru: "Премиальные этно-путешествия · Дикая природа · Горы", en: "Premium ethno trips · Wildlife · Mountains" },
  read_more: { ru: "Подробнее", en: "Read more" },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const q = new URLSearchParams(window.location.search).get("lang");
      if (q === "ru" || q === "en") return q;
    }
    return localStorage.getItem("argali_lang") || "ru";
  });
  const change = useCallback((l) => {
    setLang(l);
    localStorage.setItem("argali_lang", l);
  }, []);
  const t = useCallback((key) => (dict[key] ? dict[key][lang] : key), [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);